import { CampaignDetailReport, CampaignReportSummary, CampaignType, Maybe } from '@anytag/graphql';
import { ReportFilterFormValues } from '../report-filter';
import { ReportRowData, ReportStats } from './types';

export const getReportQueryVariables = (filter: ReportFilterFormValues) => ({
  ...filter,
  campaignCategoryIds: filter.campaignCategoryIds.map(Number),
  campaigns: filter.campaigns.map((campaign) => {
    const [campaignType, id] = campaign.split('/');

    return {
      id: Number(id),
      type: campaignType === 'marketplace' ? CampaignType.MARKETPLACE : CampaignType.ENGAGEMENT
    };
  })
});

const getReportStats = (stats?: Maybe<CampaignReportSummary>): ReportStats => ({
  age1824Percentage: stats?.age1824Percentage ?? null,
  age2534Percentage: stats?.age2534Percentage ?? null,
  age35UpPercentage: stats?.age35UpPercentage ?? null,
  averageViewDurationMinutes: stats?.averageViewDurationMinutes ?? null,
  averageViewDurationPercentage: stats?.averageViewDurationPercentage ?? null,
  averageViewDurationSeconds: stats?.averageViewDurationSeconds ?? null,
  back: stats?.back ?? null,
  click: stats?.click ?? null,
  comment: stats?.comment ?? null,
  conversion: stats?.conversion ?? null,
  cost: stats?.cost ?? null,
  costsPerAction: stats?.costsPerAction ?? null,
  costsPerClick: stats?.costsPerClick ?? null,
  costsPerComment: stats?.costsPerComment ?? null,
  costsPerEngagement: stats?.costsPerEngagement ?? null,
  costsPerFollower: stats?.costsPerFollower ?? null,
  costsPerImpressions: stats?.costsPerImpressions ?? null,
  costsPerLike: stats?.costsPerLike ?? null,
  costsPerOrder: stats?.costsPerOrder ?? null,
  costsPerReach: stats?.costsPerReach ?? null,
  costsPerSale: stats?.costsPerSale ?? null,
  costsPerSaleReferral: stats?.costsPerSaleReferral ?? null,
  costsPerSaleTune: stats?.costsPerSaleTune ?? null,
  costsPerSaved: stats?.costsPerSaved ?? null,
  costsPerShare: stats?.costsPerShare ?? null,
  costsPerView: stats?.costsPerView ?? null,
  dislikes: stats?.dislikes ?? null,
  engagement: stats?.engagement ?? null,
  engagementRate: stats?.engagementRate ?? null,
  engagementViewsRate: stats?.engagementViewsRate ?? null,
  exited: stats?.exited ?? null,
  femalePercentage: stats?.femalePercentage ?? null,
  followers: stats?.followers ?? null,
  forward: stats?.forward ?? null,
  impressionRate: stats?.impressionRate ?? null,
  impressions: stats?.impressions ?? null,
  impressionsFromDiscovery: stats?.impressionsFromDiscovery ?? null,
  impressionsFromHashtag: stats?.impressionsFromHashtag ?? null,
  impressionsFromHome: stats?.impressionsFromHome ?? null,
  impressionsFromOther: stats?.impressionsFromOther ?? null,
  impressionsFromProfile: stats?.impressionsFromProfile ?? null,
  interaction: stats?.interaction ?? null,
  like: stats?.like ?? null,
  linkClicks: stats?.linkClicks ?? null,
  malePercentage: stats?.malePercentage ?? null,
  navigation: stats?.navigation ?? null,
  net: stats?.net ?? null,
  nextStory: stats?.nextStory ?? null,
  nonFollowerReach: stats?.nonFollowerReach ?? null,
  nonFollowerReachRate: stats?.nonFollowerReachRate ?? null,
  orders: stats?.orders ?? null,
  profileActivity: stats?.profileActivity ?? null,
  profit: stats?.profit ?? null,
  profitRate: stats?.profitRate ?? null,
  reach: stats?.reach ?? null,
  reachRate: stats?.reachRate ?? null,
  sales: stats?.sales ?? null,
  salesReferral: stats?.salesReferral ?? null,
  salesTune: stats?.salesTune ?? null,
  saved: stats?.saved ?? null,
  share: stats?.share ?? null,
  stickerTaps: stats?.stickerTaps ?? null,
  view: stats?.view ?? null,
  retweets: stats?.share ?? null // Retweets get data from share, following the pattern from PostReportTable
});

export const formatReportData = (data: readonly CampaignDetailReport[], summary?: Maybe<CampaignReportSummary>) =>
  [
    { className: 'total-row', stats: getReportStats(summary) },
    ...data.map<ReportRowData>((item) => ({
      campaign: item.campaign,
      stats: getReportStats(item)
    }))
  ] satisfies ReportRowData[];
